import { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { communityData } from '../../components/Tab/TabData';

import { PageControlBtns } from '../../components/Button/Button';

import { DownloadLink } from '../../utils/DownloadFunctions';
import { fetchGet } from '../../hooks/fetch';
import Loading from '../Loading';

export default function ArchiveDetail() {
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');
	const location = useLocation();
	const { page, searchText } = location.state || {};

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const pageName = '자료실';

	const { id } = useParams();
	const [post, setPost] = useState();

	function getPost() {
		fetchGet(
			`/archive/${id}`,
			(json) => {
				setPost(json);
				setIsLoading(false);
			}
		)
	}

	useEffect(() => {
		setIsLoading(true);
		getPost();
	}, []);
	
	return (
		<main id="program-page-wrap">
			<h1 className="sr-only">{`${pageName} 보기 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={communityData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						{post ? (
							<div className="detail-form-con">
								<div className="dv-header">
									<div className="gs-infos-badge">
										<div className="info-2">
											<h2>{post.title}</h2>
											<p>{post.summary}</p>
										</div>
										<div className="info-3">
											<div className="gs-unit pipeline gray">
												<span>{post.createdBy}</span>
												<span>{post.createdDate}</span>
											</div>
										</div>
									</div>
								</div>
								<div className="dv-body">
									<div dangerouslySetInnerHTML={{ __html: post?.content }} />
									
									{post.files?.length > 0 && (
										<div className="gs-file-wrap col">
											<div className="label">첨부파일</div>
											<div className="gs-files-con">
												<ul className="gs-files">
													{post.files?.map((f, i) => <li><DownloadLink name={f.name} uid={f.uid} /></li>)}
												</ul>
											</div>
										</div>
									)}
								</div>
							</div>
						) : (
							isLoading ? <Loading /> : <div className="gs-no-con">해당 게시글을 찾을 수 없습니다.</div>
						)}
					</div>
					<PageControlBtns listUrl={`/community/archive?page=${page}&searchText=${searchText}`} />
				</div>
			</Container>
		</main>
	);
}
